import { TimePreset } from '../../../schema/hannibal/types.generated';
import { Metro } from '../../SearchHeader/constants';
import { makeSearchUrl } from '../../SearchHeader/urls/makeSearchUrl';

export const GP_APPOINTMENTS = makeSearchUrl({
  topic: { specialist: 'gp' },
  onlineAppointments: {},
});

export const AFTER_HOURS_GP_APPOINTMENTS = makeSearchUrl({
  topic: { specialist: 'gp' },
  onlineAppointments: { time: TimePreset.AfterHours },
});

export const BULK_BILLING_GP_APPOINTMENTS = makeSearchUrl({
  topic: { bulkBillingGp: true },
  onlineAppointments: {},
});

export const DENTIST_APPOINTMENTS = makeSearchUrl({
  topic: { specialist: 'dentist' },
  onlineAppointments: {},
});

export const PHYSIO_APPOINTMENTS = makeSearchUrl({
  topic: { specialist: 'physiotherapist' },
  onlineAppointments: {},
});

export const CHIRO_APPOINTMENTS = makeSearchUrl({
  topic: { specialist: 'chiropractor' },
  onlineAppointments: {},
});

export const PSYCH_APPOINTMENTS = makeSearchUrl({
  topic: { specialist: 'psychologist' },
  onlineAppointments: {},
});

export const SYDNEY_DENTISTS = makeSearchUrl({
  topic: { specialist: 'dentist' },
  location: { metro: Metro.Sydney },
});

export const MELBOURNE_DENTISTS = makeSearchUrl({
  topic: { specialist: 'dentist' },
  location: { metro: Metro.Melbourne },
});

export const DENTIST = makeSearchUrl({ topic: { specialist: 'dentist' } });

export const BRISBANE_DENTISTS = makeSearchUrl({
  topic: { specialist: 'dentist' },
  location: { metro: Metro.Brisbane },
});

export const ONLINE_DOCTORS = makeSearchUrl({
  flag: 'telehealth',
  topic: { specialist: 'gp' },
  onlineAppointments: {},
});

export const ONLINE_GPS = makeSearchUrl({
  flag: 'telehealth',
  topic: { specialist: 'gp' },
});
